import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { IOrderSlice } from "./types";

const selectSelf = (state: RootState) => state;
const selectOrder = createSelector(selectSelf, (state) => state.order);

export const selectIsOrderLoading = createSelector(
  selectOrder,
  (order) => order.isLoading
);

export const selectOrders = createSelector(
  selectOrder,
  (order) => order.orders
);

export const selectSelectedCustomerOrders = createSelector(
  selectOrder,
  (order) => order.selectedCustomerOrders
);

export const selectOrderIds = createSelector(
  selectOrder,
  (order) => order.orderIds
);

export const selectSelectedOrderDetails = createSelector(
  selectOrder,
  (order: IOrderSlice) => order.selectedOrderDetails
);

export const selectFilteredOrders = createSelector(
  selectOrder,
  (order) => order.filteredOrders
);

export const selectCreateddOrders = createSelector(
  selectOrder,
  (order) => order.createdOrder
);

export const selectTagCode = createSelector(
  selectOrder,
  (order) => order.tag_code
);

export const selectTagCodeLoading = createSelector(
  selectOrder,
  (order) => order.tagCodeLoading
);

export const selectTagCodeError = createSelector(
  selectOrder,
  (order) => order.tagCodeError
);

export const selectOrderTracking = createSelector(
  selectOrder,
  (order) => order.orderTracking
);
